// src/types/typescript-utils.ts
import { Type as T } from "@sinclair/typebox";
var { String: StringTB, Optional: OptionalTB, Boolean: BooleanTB, Object: ObjectTB, Number: NumberTB } = T;
var Str = StringTB.bind(T);
var Num = NumberTB.bind(T);
var Obj = ObjectTB.bind(T);
var Opt = OptionalTB.bind(T);
var Bool = BooleanTB.bind(T);
var STR = Str();
var NUM = Num();
var BOOL = Bool();
function checkParityTB() {
  const s1 = Str();
  const s2 = Str();
  const n1 = Num();
  const n2 = Num();
  console.log({ s1, s2, n1, n2 });
}
function arrayIfSingle(arrOrSingle) {
  if (Array.isArray(arrOrSingle)) return arrOrSingle;
  else return [arrOrSingle];
}

export {
  Str,
  Num,
  Obj,
  Opt,
  Bool,
  STR,
  NUM,
  BOOL,
  checkParityTB,
  arrayIfSingle
};
//# sourceMappingURL=chunk-ZAADLBSB.js.map